export enum LocumsFlags {    
    LocumsBookedDaysCalendarSchedule = 'locums-booked-days-calendar-schedule',
    BookedDaysScrollableCalendar = 'booked-days-scrollable-calendar',
    LocumsCandidateProfileWeeklySchedule = 'locums-candidate-profile-weekly-schedule',
    LocumsContractBookedDaysSaving = 'locums-contract-booked-days-saving',
    ProviderScheduleExportBookedDays = 'provider-schedule-export-booked-days',
    ShiftManagementFacilitySchedule = 'shift-management-facility-schedule',
    AddNpiVerificationToHiringOppsCandidateApi = 'add-npi-verification-status-to-hiring-opps-candidate-api',
    FacilitySchedulePayBillRatesDayCard = 'facility-schedule-pay-bill-rates-day-card',
    BookedDaysShiftTimes = 'booked-days-shift-times',
    FacilityScheduleExportShiftTimes = 'facility-schedule-export-shift-times',
    LocumsAMEditBookedDaysStandalone = 'locums-am-edit-booked-days-standalone',
    FacilityScheduleAdditionalFilters = 'facility-schedule-additional-filters',
    JobEditMenuWillingToLicenseAndJobSource = 'job-edit-menu-willing-to-license-and-job-source',
    BookedDaysEditEndTime = 'booked-days-edit-end-time',
    LocumsSaveAndSendSummarySchedule = 'locums-save-and-send-summary-schedule',
    LocumsDuplicateJobDoNotCopyPayOverride = 'locums-duplicate-job-do-not-copy-pay-override',
    FacilitiesAssignToFloatPool = 'facilities-assign-to-float-pool',
    BookedDaysFloatPoolsLocation = 'booked-days-float-pools-location'
}
